import React from 'react'
import logo from '../../assets/I-CONTA.png'
import './footer.css';


const Footer = () => {
    return (
        <div className='iconta__footer section__padding' id='footer'>
            <div className='iconta__footer-links'>
                <div className='iconta__footer-links_logo'>
                <img src={logo} alt="logo" />
                </div>
                <div className='iconta__footer-links_info'>
                    <h4>Contact</h4>
                    <div />
                    <p><a href='https://www.google.com/maps/place/Sector+4,+Bucharest/@44.3818772,26.0551909,12z/data=!3m1!4b1!4m5!3m4!1s0x40b1fe0d5b715d0b:0xfa8fc62cda461d44!8m2!3d44.3753564!4d26.1218478' target='_blank' rel='noreferrer'>București, Sector 4</a></p>
                    <p>(+40) 734 785 933</p>
                    <p>icont.office@gmail.com</p>
                </div>
                <div className='iconta__footer-links_info'>
                    
                    <h4>Legături utile</h4>
                    <div />
                    <p><a href='https://www.anaf.ro/anaf/internet/ANAF/acasa/!ut/p/a1/hc6xDoIwEAbgZ2Ho2jtRCHHDhUocxEXoYkpSCgZbUiq8vtU4OCjedn--y3_AoQSuxdQp4TqjRf_ceXxhKxazMAlzZAViEe32pyg7ImYbDyoP8Mek-O_-DHyRYPwGCxU5cNWb-vVulep6nSjgVjbSSkvv1setc8O4JUhwnmcqtGioNQS_-daMDsoPBsOtxGvUT4c0CB5h5prT/dl5/d5/L2dBISEvZ0FBIS9nQSEh/' target='_blank' rel='noreferrer'> ANAF</a></p>
                    <p><a href='https://ec.europa.eu/taxation_customs/vies/' target='_blank' rel='noreferrer'>VIES</a></p>
                    <p><a href='https://www.onrc.ro/index.php/ro/' target='_blank' rel='noreferrer'>Registrul Comerțului</a></p>
                    <p><a href='https://www.anaf.ro/RegistruTVA/' target='_blank' rel='noreferrer'>Verificare TVA</a></p>
                    <p><a href='http://www.itmbucuresti.ro/' target='_blank' rel='noreferrer'>ITM București</a></p>
                </div>
            </div>
        </div>
    )
}

export default Footer
